import { Link } from 'react-router';
import { stillExpected } from '@tahi/core';
import { ComingInCard, SavingsCard, YourMoneyCard } from '../components/MoneyCards';
import { copy } from '../copy';
import { useBudgetToday } from '../hooks';
import { ScreenHeader } from '../../../ui';
import { ACCENT_LINK, QUIET_LINK, SCREEN } from '../styles';

const BACK = { to: '/m/budget', label: copy.moduleName };

/** v0.5: Your money (accounts used for spending), v0.6 Savings (savings-only), then Coming in. */
export function AccountsScreen() {
  const s = useBudgetToday();
  if (!s) {
    return (
      <main className={SCREEN}>
        <ScreenHeader title={copy.accounts} back={BACK} />
        <p className="text-muted">{copy.loading}</p>
      </main>
    );
  }
  const accountName = (id: string | null) =>
    (id && s.accounts.find((a) => a.id === id)?.name) || null;
  return (
    <main className={SCREEN}>
      <ScreenHeader
        title={copy.accounts}
        back={BACK}
        actions={
          <>
            {s.accounts.length >= 2 ? (
              <Link to="/m/budget/transfer" className={QUIET_LINK}>
                {copy.transfer}
              </Link>
            ) : null}
            <Link to="/m/budget/accounts/new" className={ACCENT_LINK}>
              {copy.addAccount}
            </Link>
          </>
        }
      />
      <YourMoneyCard s={s} />
      <SavingsCard s={s} />
      <ComingInCard
        items={stillExpected(s.expected, s.today)}
        accountName={accountName}
        today={s.today}
      />
    </main>
  );
}
